import React from 'react';
import { Sparkles, Smile, Moon, CloudFog, Zap } from 'lucide-react';
import './MoodSelector.css';

export type Mood = 'inspired' | 'okay' | 'tired' | 'blocked' | 'energized';

export interface MoodOption {
  value: Mood;
  label: string;
  icon: React.ReactNode;
  color: string;
}

const moodOptions: MoodOption[] = [
  { value: 'inspired', label: 'Inspired', icon: <Sparkles />, color: 'var(--color-mood-inspired)' },
  { value: 'okay', label: 'Okay', icon: <Smile />, color: 'var(--color-mood-okay)' },
  { value: 'tired', label: 'Tired', icon: <Moon />, color: 'var(--color-mood-tired)' },
  { value: 'blocked', label: 'Blocked', icon: <CloudFog />, color: 'var(--color-mood-blocked)' },
  { value: 'energized', label: 'Energized', icon: <Zap />, color: 'var(--color-mood-energized)' },
];

export interface MoodSelectorProps {
  value?: Mood;
  onChange: (mood: Mood) => void;
  size?: 'sm' | 'md' | 'lg';
  showLabels?: boolean;
}

export const MoodSelector: React.FC<MoodSelectorProps> = ({
  value,
  onChange,
  size = 'md',
  showLabels = true,
}) => {
  return (
    <div className={`mood-selector mood-selector--${size}`}>
      {moodOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`mood-option ${value === option.value ? 'mood-option--selected' : ''}`}
          onClick={() => onChange(option.value)}
          style={{ '--mood-color': option.color } as React.CSSProperties}
          aria-pressed={value === option.value}
          aria-label={option.label}
        >
          <span className="mood-option__icon">{option.icon}</span>
          {showLabels && <span className="mood-option__label">{option.label}</span>}
        </button>
      ))}
    </div>
  );
};

export default MoodSelector;
